import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataDestService } from '../../component-data-dest.service';
import { ComponentDataSourceService } from '../../../component-data-source/component-data-source.service';
import { environment } from '../../../../environment/environment';

export interface CompleteInstructorInvitationPayload {
  invitation_guid: string;
}

export const complete_instructor_invitation = (
  service: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: CompleteInstructorInvitationPayload
): Observable<any> => {
  const guid = data.invitation_guid;
  return service.http.post(
    `${environment.apiUrl}/events/instructor-invitations/${guid}/complete`,
    {}
  ).pipe(
    catchError(error => {
      console.error('[complete_instructor_invitation] Error:', error);
      throw error;
    })
  );
};
